import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import Sidebar from "react-sidebar"
import { Button, DisplayText, Card, TextField, Icon, Stack, Toast } from "@shopify/polaris"
import {
    ChevronLeftMinor,
    ArrowRightMinor,
    SettingsMajor,
    ChevronRightMinor,
} from "@shopify/polaris-icons"
import BiSLeftLayout from "../BiSLeftLayout"
import Preloader from "../../components/Preloader"
import EditorConvertToHTML from "../../components/EditorConvertToHTML"
const INITIAL_STATE = {
    isReady: false,
    isLoading: false,
    openSidebar: false,
    openTemplateCustom: false,
    toast: {
        show: false,
        content: "",
        error: false,
    },
    wishlist_settings_edited: [],
    compare_settings_edited: [],
    general_settings_edited: [],
    errorValidate: {
        error_1: "", // wishlist add class error
        error_2: "", // wishlist show class error
        error_2a: "", // wishlist remove class error
        error_3: "", // compare add class error
        error_4: "", // compare show class error
        error_4a: "", // compare remove class error
    },
}

function mapStateToProps(state) {
    return {
        widgets: state.widgets,
        widget_selected: state.widget_selected,
        layout_button: state.layout_button,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class BiSSetting extends Component {
    constructor(props) {
        super(props)
        this.state = Object.assign({}, INITIAL_STATE)
        // this.child = React.createRef();
    }

    static getDerivedStateFromProps(props, state) {
        const { widget_selected } = props

        if (JSON.stringify(widget_selected) !== "{}") {
            return { isReady: true }
        }

        return null
    }

    componentDidMount() {
        const { actions, yout_app } = this.props
    }

    renderLeftContent = () => {
        const { redirectToPage } = this.props
        return <BiSLeftLayout goBack={async () => redirectToPage("WidgetsManagement")} />
    }

    render() {
        const { redirectToPage, actions, widget_selected } = this.props
        const { openSidebar, toast, isReady, isLoading } = this.state
        return isReady ? (
            <div className="widget-create">
                {isLoading && <Preloader />}

                <Card.Section>
                    <div className="page-breadcrumbs">
                        <Button
                            plain
                            icon={ChevronLeftMinor}
                            size="slim"
                            onClick={async () => redirectToPage("WidgetsManagement")}
                        >
                            Back to list
                        </Button>
                    </div>

                    <div className="page-title">Back In Stock Alert Settings</div>
                </Card.Section>

                <Card.Section>
                    <div className="section-title">
                        <DisplayText size="small">Adjust settings</DisplayText>
                    </div>

                    {/* Mobile section */}
                    <div
                        className="mobile-section-title"
                        onClick={() => this.setState({ openSidebar: !openSidebar })}
                    >
                        <div className="title">
                            <div className="btn-icon">
                                {openSidebar ? (
                                    <Icon source={ChevronLeftMinor} color="white" />
                                ) : (
                                    <Icon source={SettingsMajor} color="white" />
                                )}
                            </div>
                            <div className="subtitle">
                                {openSidebar ? "Back to preview" : "Wiget Settings"}
                            </div>
                        </div>
                        <div className="btn-icon">
                            {!openSidebar && <Icon source={ChevronRightMinor} color="white" />}
                        </div>
                    </div>

                    {/* Desktop section */}
                    <div className="widget-create-body" id="yta-widget-create-body">
                        <div className="left-content">{this.renderLeftContent()}</div>
                        <div className="right-content">
                            <div className="preview-block">
                                <div className="centered-content preview-component">
                                    <div style={{ width: "500px" }}>
                                        <Card>
                                            <EditorConvertToHTML checkBiS={true} />
                                        </Card>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`sidebar sidebar-${openSidebar ? "open" : "hidden"}`}>
                            <Sidebar
                                sidebar={this.renderLeftContent()}
                                open={openSidebar}
                                onSetOpen={() => this.setState({ openSidebar: !openSidebar })}
                            >
                                <div></div>
                            </Sidebar>
                        </div>
                    </div>
                </Card.Section>

                {toast.show && (
                    <Toast
                        content={toast.content}
                        error={toast.error}
                        onDismiss={() =>
                            this.setState({
                                toast: { show: false, content: "", error: false },
                            })
                        }
                    />
                )}
            </div>
        ) : (
            <Preloader />
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(BiSSetting)
